import useLocationHash, { pushLocation } from "../hooks/useLocationHash";
import ResultsList from "./ResultsList";

type Years = { years: string[] };
type LotsByYear = { [key: string]: Results.Lot[] };

type Props = {
  lots: LotsByYear & Years;
  base_url: string;
  strings: Record<string, string>;
};

export default function TopResults({ lots, base_url, strings }: Props) {
  const hash = useLocationHash();
  const filter = hash.match(/([\w\d]+)/)?.[0] ?? "all";

  const allYearsRange = () => {
    const years = lots.years;
    return `${years[years.length - 1]}–${years[0]}`;
  };

  const updateFilter = (filter: string) => {
    let url = document.location.pathname;
    if (filter !== "all") {
      url += `#${filter}`;
    }
    pushLocation(url);
  };

  const filteredLots = () => {
    return lots[filter];
  };

  const lotItems = filteredLots();

  return (
    <div className="top-results">
      <div className="filter">
        <select
          name="filter-top-results"
          value={filter}
          onChange={(e) => updateFilter(e.target.value)}>
          <option value="all">{allYearsRange()}</option>
          {lots.years.map((y) => (
            <option key={`year-${y}`} value={y}>
              {y}
            </option>
          ))}
        </select>
      </div>
      <ResultsList
        lots={lotItems}
        base_url={base_url}
        sold_date={true}
        strings={strings}
      />
    </div>
  );
}
